import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';
import { keyframes } from '@emotion/react';
import { useTranslation } from 'react-i18next'; // 1. Import the hook

import Logo from '../assets/images/aduu.png'; // Replace with your actual logo path

// A subtle fade-in and slide-up animation
const fadeInUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const IntroductionSection = () => {
  const { t } = useTranslation(); // 2. Initialize the translation function

  // Define a "Stone White" background color for easy reuse.
  const stoneWhite = '#efebda';

  return (
    <Box
      component="section"
      id="introduction"
      sx={{
        backgroundColor: stoneWhite,
        py: { xs: 8, md: 12 },
        overflow: 'hidden',
        width: '100vw',
      }}
    >
      <Container maxWidth="lg">
        <Grid 
          container 
          spacing={{ xs: 6, md: 0 }}
          alignItems="center"
        >
          {/* Left Column: Logo and Tagline */}
          <Grid 
            item 
            size={{ xs: 12, md: 5 }}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: { xs: 'center', md: 'flex-start' }, 
              textAlign: { xs: 'center', md: 'left' },
              animation: `${fadeInUp} 1s ease-out`,
            }}
          >
            <Box sx={{ color: 'primary.main' }}>
              {/* 3. Use the t() function for the alt tag */}
              <img src={Logo} alt={t('intro_logo_alt')} style={{ height:'400px', }}/>
            </Box>
          </Grid>

          {/* Right Column: Heading and Paragraph */}
          <Grid 
            item 
           size={{ xs: 12, md: 7 }}
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              animation: `${fadeInUp} 1s ease-out 0.2s`,
              animationFillMode: 'forwards',
              opacity: 0,
            }}
          >
            <Typography
              variant="h3"
              component="h2"
              sx={{
                fontWeight: 500,
                mb: 3,
                lineHeight: 1.3,
                fontFamily: 'serif',
                color:'#005B4B'
              }}
            >
              {/* 3. Use the t() function for the heading */}
              {t('intro_headline')}
            </Typography>
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: '1rem', md: '1.1rem' },
                lineHeight: 1.7,
                color: '#2E3836',
              }}
            >
              {/* 3. Use the t() function for the paragraph */}
              {t('intro_paragraph')}
            </Typography>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default IntroductionSection;